/**
 * @generated SignedSource<<578dcfd32f30b6d3b9c65530caf4ca4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnalytics"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isAnalytics",
        "variableName": "isAnalytics"
      },
      {
        "kind": "Variable",
        "name": "itemType",
        "variableName": "itemType"
      },
      {
        "kind": "Variable",
        "name": "offerId",
        "variableName": "offerId"
      },
      {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
      }
    ],
    "concreteType": "Tag",
    "kind": "LinkedField",
    "name": "tags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "itemType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "itemsIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Dates",
        "kind": "LinkedField",
        "name": "dates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastUpdate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QTagsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QTagsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "830ac2a4e5315789dad7d6f0609fbde2",
    "id": null,
    "metadata": {},
    "name": "QTagsQuery",
    "operationKind": "query",
    "text": "query QTagsQuery(\n  $scope: DocumentScopeEnum!\n  $offerId: ID\n  $itemType: String\n  $isAnalytics: Boolean\n) {\n  tags(scope: $scope, offerId: $offerId, itemType: $itemType, isAnalytics: $isAnalytics) {\n    id\n    name\n    itemType\n    itemsIds\n    color\n    isDefault\n    dates {\n      creation\n      lastUpdate\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c436f2187fdf66de01c622c52be40e23";

export default node;
